// extracted by mini-css-extract-plugin
export default {"change-plan-page":"style_change-plan-page__3jXuk","change-plan-title":"style_change-plan-title__PvgYo","change-plan-content":"style_change-plan-content__tVrJE"};